var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDummyProduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.683594,
    y: 0.367188,
    width: 38,
    height: 38,
    rx: 4.52381,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2836 13.3672H14.0836C13.3115 13.3672 12.6836 13.9951 12.6836 14.7672V23.1672C12.6836 23.9393 13.3115 24.5672 14.0836 24.5672H25.2836C26.0557 24.5672 26.6836 23.9393 26.6836 23.1672V14.7672C26.6836 13.9951 26.0557 13.3672 25.2836 13.3672ZM15.8336 15.4672C16.1121 15.4672 16.3791 15.5778 16.5761 15.7747C16.773 15.9716 16.8836 16.2387 16.8836 16.5172C16.8836 16.7957 16.773 17.0627 16.5761 17.2596C16.3791 17.4566 16.1121 17.5672 15.8336 17.5672C15.5551 17.5672 15.288 17.4566 15.0911 17.2596C14.8942 17.0627 14.7836 16.7957 14.7836 16.5172C14.7836 16.2387 14.8942 15.9716 15.0911 15.7747C15.288 15.5778 15.5551 15.4672 15.8336 15.4672ZM19.6836 22.4672H14.7836L17.5836 18.9672L18.6336 20.3672L20.7336 17.5672L24.5836 22.4672H19.6836Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyProduct);
export default __webpack_public_path__ + "static/media/dummyProduct.6f4acb02ecc7407383d2a6382b7759d7.svg";
export { ForwardRef as ReactComponent };